import React, { useState } from 'react';
import Tab, { TabGroup } from '@amzn/meridian/tab';
import Expander from '@amzn/meridian/expander';
import Text from '@amzn/meridian/text';
import { BUSINESS_VIEW_NAME, DEFAULT_SPEED, CORE_BUSINESS_TYPE_LABEL } from '../../utils/constants';
import { trimAndCapitalizeFirstLetter } from '../../utils/helpers';

const BusinessTabsAndSpeeds = ({
  data,
  renderChildComponent,
  selectedBusiness,
  setSelectedBusiness,
  isGroceryEnabled = false,
  isRushEnabled = false,
  isGroceryIndirectRulesEnabled = false,
  showSpeedAccordians = false
}) => {
  if (showSpeedAccordians && (!data || !renderChildComponent)) {
    return <Text>Missing data or render component</Text>;
  }
  const [expandedSpeeds, setExpandedSpeeds] = useState(new Set([DEFAULT_SPEED]));
  const businesses = data ? Object.keys(data || {}) : Object.values(BUSINESS_VIEW_NAME);

  const handleBusinessChange = (newBusiness) => {
    setSelectedBusiness(newBusiness);
    setExpandedSpeeds(new Set([DEFAULT_SPEED]));
  };

  const toggleSpeed = (speed) => {
    setExpandedSpeeds((prev) => {
      const newSet = new Set(prev);
      newSet.has(speed) ? newSet.delete(speed) : newSet.add(speed);
      return newSet;
    });
  };

  const visibleBusinesses = businesses.filter((business) => {
    if (business === BUSINESS_VIEW_NAME.GROCERY && (isGroceryEnabled || isGroceryIndirectRulesEnabled)) {
      return business;
    }

    return business;
  });

  const visibleSpeeds = () => {
    const allSpeeds = Object.keys(data[selectedBusiness] || {});
    if (!isRushEnabled) {
      return allSpeeds.filter((speed) => speed === DEFAULT_SPEED);
    }

    return allSpeeds;
  };

  const ControlledExpander = (props) => {
    const [open, setOpen] = useState(true);
    return <Expander open={open} onChange={setOpen} {...props} />;
  };

  return (
    <React.Fragment>
      {/** Business Tabs */}
      <TabGroup value={selectedBusiness} onChange={handleBusinessChange} type="default" fill="line">
        {visibleBusinesses.map((business) => {
          return (
            <Tab key={business} value={business}>
              {business === BUSINESS_VIEW_NAME.CORE ? CORE_BUSINESS_TYPE_LABEL : trimAndCapitalizeFirstLetter(business)}
            </Tab>
          );
        })}
      </TabGroup>

      {/** Speed Accordions */}
      {showSpeedAccordians &&
        selectedBusiness &&
        visibleSpeeds().map((speed) => {
          const isOpen = expandedSpeeds.has(speed);
          const filteredData = data[selectedBusiness][speed];
          return (
            <ControlledExpander
              key={speed}
              open={isOpen}
              title={speed}
              type="section"
              onChange={() => toggleSpeed(speed)}>
              {isOpen && renderChildComponent(filteredData)}
            </ControlledExpander>
          );
        })}
    </React.Fragment>
  );
};

export default BusinessTabsAndSpeeds;
